import Vue from 'vue';

//helper app
import './Components/Helpers/HelperComponent';

/**
 * all component of GUD
 */
Vue.component('personal-information', require('./Components/Views/Auth/PersonalInformation').default);
Vue.component('password-change', require('./Components/Views/Auth/PasswordChange').default);
Vue.component('social-links', require('./Components/Views/Auth/SocialLinks').default);
Vue.component('login', require('./Components/Views/Auth/Login').default);
Vue.component('password-reset', require('./Components/Views/Auth/PasswordReset').default);
Vue.component('reset-password', require('./Components/Views/Auth/ResetPassword').default);
Vue.component('registration', require('./Components/Views/Auth/Registration').default);
Vue.component('my-profile', require('./Components/Views/Auth/Profile').default);

// Settings
Vue.component('app-setting', require('./Components/Views/Settings/Index').default);
Vue.component('general-setting', require('./Components/Views/Settings/GeneralSetting').default);
Vue.component('email-setting', require('./Components/Views/Settings/EmailSetting').default);
Vue.component('sms-setting', require('./Components/Views/Settings/SmsSetting').default);
Vue.component('google-re-captcha-setting', require('./Components/Views/Settings/GoogleRecaptchaSetting').default);
Vue.component('notification-settings', require('./Components/Views/Settings/Notification/Settings/Index').default);
Vue.component('database-template', require('./Components/Views/Settings/Notification/Template/DatabaseTemplate').default);
Vue.component('mail-template', require('./Components/Views/Settings/Notification/Template/MailTemplate').default);
Vue.component('payment-method', require('./Components/Views/Settings/PaymentMethod/PaymentMethod').default);
Vue.component('payment-method-create-edit-modal', require('./Components/Views/Settings/PaymentMethod/PaymentMethodCreateEditModal').default);

// User and Roles
Vue.component('user-roles', require('./Components/Views/UserRoles/Index').default);
Vue.component('group-of-users', require('./Components/Views/UserRoles/Roles/GroupOfUsers').default);

// Users Management
Vue.component('user-management', require('./Components/Views/Users/Index').default);
Vue.component('user-add-edit-modal', require('./Components/Views/Users/UserAddEditModal').default);

// Layouts
Vue.component('app-top-bar', require('./Components/Views/Layouts/Nabar').default);
Vue.component('app-sidebar', require('./Components/Views/Layouts/Sidebar').default);

// notifications
Vue.component('all-notification', require('./Components/Views/Auth/Notification').default);

Vue.component('re-captcha', require('./Components/Views/Auth/ReCaptcha').default);
Vue.component('payment-view', require('./Components/Views/Demo/Pages/PaymentMethodView').default);

//Custom Table
Vue.component('app-custom-tables', require('./Components/Views/Settings/CustomTable/CustomTable').default)
Vue.component('app-custom-table-modal', require('./Components/Views/Settings/CustomTable/CustomTableModal').default)

// Dynamic table
Vue.component('app-custom-table-dynamic', require('./Components/Views/Demo/CustomTable/DynamicPage').default)

// Location
Vue.component('location', require('./Components/Views/Location/Index').default);
Vue.component('location-add-edit-modal', require('./Components/Views/Location/LocationAddEditModal').default);
// Employee
Vue.component('employee', require('./Components/Views/Employee/Index').default);
Vue.component('employee-add-edit-modal', require('./Components/Views/Employee/EmployeeAddEditModal').default);
// Attendance
Vue.component('attendance', require('./Components/Views/Attendance/Index').default);
Vue.component('attendance-add-edit-modal', require('./Components/Views/Attendance/AttendanceAddEditModal').default);
// Attendance Dashboard Components
Vue.component('attendance-navigation', require('./Components/Views/Attendance/Navigation').default);
Vue.component('dashboard-summary', require('./Components/Views/Attendance/DashboardSummary').default);
Vue.component('employee-details', require('./Components/Views/Attendance/EmployeeDetails').default);
Vue.component('real-time-stats', require('./Components/Views/Attendance/RealTimeStats').default);
Vue.component('attendance-reports', require('./Components/Views/Attendance/Reports').default);
Vue.component('app-monthly-attendance-calendar', require('./Components/Views/Attendance/MonthlyCalendar').default);
// Working Shift
Vue.component('working-shift', require('./Components/Views/WorkingShift/Index').default);
Vue.component('working-shift-add-edit-modal', require('./Components/Views/WorkingShift/WorkingShiftAddEditModal').default);
// Leave Type
Vue.component('leave-type', require('./Components/Views/LeaveType/Index').default);
Vue.component('leave-type-add-edit-modal', require('./Components/Views/LeaveType/LeaveTypeAddEditModal').default);
// Leave
Vue.component('leave', require('./Components/Views/Leave/Index').default);
Vue.component('leave-add-edit-modal', require('./Components/Views/Leave/LeaveAddEditModal').default);
// Department
Vue.component('department', require('./Components/Views/Department/Index').default);
Vue.component('department-add-edit-modal', require('./Components/Views/Department/DepartmentAddEditModal').default);
// Bank
Vue.component('bank', require('./Components/Views/Bank/Index').default);
Vue.component('bank-add-edit-modal', require('./Components/Views/Bank/BankAddEditModal').default);
// Category
Vue.component('category', require('./Components/Views/Category/Index').default);
Vue.component('category-add-edit-modal', require('./Components/Views/Category/CategoryAddEditModal').default);
// Payroll Period
Vue.component('payroll-period', require('./Components/Views/PayrollPeriod/Index').default);
Vue.component('payroll-period-add-edit-modal', require('./Components/Views/PayrollPeriod/PayrollPeriodAddEditModal').default);
// Payroll
Vue.component('payroll', require('./Components/Views/Payroll/Index').default);
Vue.component('payroll-add-edit-modal', require('./Components/Views/Payroll/PayrollAddEditModal').default);
// Payroll Setting
Vue.component('payroll-setting', require('./Components/Views/PayrollSetting/Index').default);

// Salary Advance
Vue.component('salary-advance', require('./Components/Views/SalaryAdvance/Index').default);
Vue.component('salary-advance-add-edit-modal', require('./Components/Views/SalaryAdvance/SalaryAdvanceAddEditModal').default);
// Job Title
Vue.component('job-title', require('./Components/Views/JobTitle/Index').default);
Vue.component('job-title-add-edit-modal', require('./Components/Views/JobTitle/JobTitleAddEditModal').default);
// Holiday
Vue.component('holiday', require('./Components/Views/Holiday/Index').default);
Vue.component('holiday-add-edit-modal', require('./Components/Views/Holiday/HolidayAddEditModal').default);
// Payment Listing
Vue.component('payment-listing', require('./Components/Views/PaymentListing/Index').default);
Vue.component('payment-listing-add-edit-modal', require('./Components/Views/PaymentListing/PaymentListingAddEditModal').default);
